import { useEffect, useState } from 'react';
import Spinner from '../spinner/spinner';
import { LOCALE } from '../../locales';
import logoBox from '../../assets/miele-logo-box.webp';
import { track, TRACK } from '../../libs/teads-tracking';
import './start-screen-v2.css';

// V2 start screen (served under /v2): black screen, centered Miele logo,
// "tap to start" near the bottom, with the shared letter wave and the
// tap-to-loading burst transition. The loading state is the spinner alone.
const StartScreenV2 = ({ started, onStart }) => {
    const [launching, setLaunching] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    // The logo entrance starts only once the webp is decoded (same iOS
    // cold-load issue as the v1 screen); preloaded via Image because the
    // logo here is a CSS background.
    const [logoReady, setLogoReady] = useState(false);

    useEffect(() => {
        const image = new Image();
        image.onload = () => setLogoReady(true);
        image.src = logoBox;
    }, []);

    useEffect(() => {
        if (!launching) return;
        const timer = setTimeout(() => {
            setLaunching(false);
            setShowLoading(true);
        }, 560);
        return () => clearTimeout(timer);
    }, [launching]);

    // safety net: if the camera got started without our click flow, show loading
    useEffect(() => {
        if (started && !launching) setShowLoading(true);
    }, [started, launching]);

    function handleStart() {
        if (launching || showLoading || started) return;
        setLaunching(true);
        track(TRACK.AR);
        // must stay inside the tap's user-activation window (iOS motion permission)
        onStart();
    }

    return (
        <div className="start-screen-v2" onClick={handleStart}>
            <div className={'v2-logo' + (logoReady ? ' ready' : '')}></div>
            {showLoading ? (
                <div className="v2-loader">
                    <Spinner size={50} color="white" />
                </div>
            ) : (
                <div className={'v2-tap-text' + (launching ? ' launching' : '')}
                     aria-label={LOCALE.strings.tapToStart}>
                    {LOCALE.strings.tapToStart.split('').map((ch, i) => (
                        <span key={i}
                              className="v2-letter"
                              style={{ animationDelay: `${i * 0.08}s` }}
                              aria-hidden="true">
                            {ch === ' ' ? ' ' : ch}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default StartScreenV2;
